import React from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import usePlace from './usePlace'

import Button from 'components/UI/Button'
import Icon from 'components/Icon'
import LoadingIndicator from 'components/LoadingIndicator'

import './maps-selected-place.pcss'

const MapsSelectedPlace = ({ t, point, placeId, onSelect }) => {
    const [loadedPlace, loading] = usePlace({ placeId })

    const selectedPlace = loadedPlace
    const selectedPoint = selectedPlace ? {
        lat: selectedPlace.geometry.location.lat(),
        lng: selectedPlace.geometry.location.lng(),
    } : (
        point
    )

    const handleClick = () => {
        onSelect(selectedPoint, selectedPlace)
    }

    return (
        <div className="maps-selected-place">
            <div className="maps-selected-place__icon">
                {loading ? (
                    <LoadingIndicator size="s" type="plain" />
                ) : (
                    <Icon fa name="map-marker-alt" color="#cc3300" />
                )}
            </div>
            {!loading && (
                <div className="maps-selected-place__address">
                    <span className="maps-selected-place__name">
                        {selectedPlace ? (
                            selectedPlace.name || selectedPlace.formatted_address
                        ) : (
                            t('maps:centerPoint')
                        )}
                    </span>
                    {selectedPlace && (
                        <span className="maps-selected-place__vicinity">
                            {selectedPlace.vicinity}
                        </span>
                    )}
                </div>
            )}
            {!loading && (
                <Button
                    type="button"
                    className="button maps-selected-place__select-button"
                    trackName="placeSelect"
                    onClick={handleClick}
                    disabled={loading}
                >
                    <span className="s-down-only">{t('maps:selectLocationShort')}</span>
                    <span className="s-up-only">{t('maps:selectLocation')}</span>
                </Button>
            )}
        </div>
    )
}

MapsSelectedPlace.propTypes = {
    t: PropTypes.func.isRequired,
    point: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
    }).isRequired,
    place: PropTypes.object,
    onSelect: PropTypes.func.isRequired,
}

export default withTranslationCustom('maps')(MapsSelectedPlace)
